import axios from 'axios';

export const fetchLoginNotificationApi = async (authtoken) => {
  const axiosInstance = axios.create({
    withCredentials: true
  });
  return await axiosInstance.get(process.env.REACT_APP_API + '/notification/login-message', {
    headers: {
      authtoken
    }
  });
};

export const updateLoginNotificationApi = async (authtoken, message) => {
  const axiosInstance = axios.create({
    withCredentials: true
  });
  return await axiosInstance.post(
    process.env.REACT_APP_API + '/notification/login-message',
    { message },
    {
      headers: {
        authtoken
      }
    }
  );
};
